// Theme toggle persisted to localStorage. Sets `dark` class on <html> so Tailwind `dark:`
// variants pick up.

import type { Theme } from './shiki';

const KEY = 'code_rag_theme';

export function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(KEY) as Theme | null;
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* ignore */
  }
}

export type { Theme };
